<div class="landing-page">
  <!-- Hero Section -->
  <section class="hero-section">
    <div class="hero-background">
      <div class="hero-overlay"></div>
    </div>
    <div class="hero-content">
      <h1 class="hero-title">Welcome to ArkifiHub</h1>
      <p class="hero-subtitle">Your Ultimate Marketplace for Everything</p>
      <p class="hero-description">
        Discover thousands of stores, millions of products, and shop with confidence. 
        Everything you need, all in one place.
      </p>
      <div class="hero-actions">
        <p-button 
          label="Explore Stores" 
          icon="pi pi-arrow-right"
          (onClick)="goToMarketplace()"
          [raised]="true"
          styleClass="hero-button"
        ></p-button>
        <p-button 
          label="Create Your Store" 
          icon="pi pi-plus"
          [outlined]="true"
          styleClass="hero-button-outline"
          (onClick)="goToCreateStore()"
        ></p-button>
      </div>
    </div>
  </section>

  <!-- Stats Section -->
  <section class="stats-section">
    <div class="stats-container">
      @for (stat of stats; track stat.label) {
        <div class="stat-item">
          <div class="stat-number">{{ stat.number }}</div>
          <div class="stat-label">{{ stat.label }}</div>
        </div>
      }
    </div>
  </section>

  <!-- Features Section -->
  <section class="features-section">
    <div class="section-container">
      <h2 class="section-title">Why Choose ArkifiHub?</h2>
      <p class="section-subtitle">Everything you need for a seamless shopping experience</p>
      <div class="features-grid">
        @for (feature of features; track feature.title) {
          <div class="feature-card">
            <div class="feature-icon">
              <i [class]="'pi ' + feature.icon"></i>
            </div>
            <h3 class="feature-title">{{ feature.title }}</h3>
            <p class="feature-description">{{ feature.description }}</p>
          </div>
        }
      </div>
    </div>
  </section>

  <!-- Featured Stores Section -->
  <section class="featured-stores-section">
    <div class="section-container">
      <h2 class="section-title">Featured Stores</h2>
      <p class="section-subtitle">Discover our most popular stores</p>
      <div class="stores-grid">
        @for (store of featuredStores; track store.name) {
          <div class="store-card" (click)="goToStore(store.name)">
            <div class="store-image-container">
              <img [src]="store.image" [alt]="store.name" class="store-image" />
              <div class="store-category-badge">{{ store.category }}</div>
            </div>
            <div class="store-info">
              <h3 class="store-name">{{ store.name }}</h3>
              <p class="store-description">{{ store.description }}</p>
              <button class="store-button">
                <span>Visit Store</span>
                <i class="pi pi-arrow-right"></i>
              </button>
            </div>
          </div>
        }
      </div>
      <div class="section-footer">
        <p-button 
          label="View All Stores" 
          icon="pi pi-th-large"
          (onClick)="goToMarketplace()"
          [outlined]="true"
        ></p-button>
      </div>
    </div>
  </section>

  <!-- Testimonials Section -->
  <section class="testimonials-section">
    <div class="section-container">
      <h2 class="section-title">What Our Customers Say</h2>
      <p class="section-subtitle">Real experiences from real customers</p>
      <div class="testimonials-grid">
        @for (testimonial of testimonials; track testimonial.name) {
          <div class="testimonial-card">
            <div class="testimonial-content">
              <div class="quote-icon">
                <i class="pi pi-quote-left"></i>
              </div>
              <p class="testimonial-text">{{ testimonial.text }}</p>
            </div>
            <div class="testimonial-author">
              <img [src]="testimonial.image" [alt]="testimonial.name" class="author-image" />
              <div class="author-info">
                <div class="author-name">{{ testimonial.name }}</div>
                <div class="author-role">{{ testimonial.role }}</div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </section>

  <!-- CTA Section -->
  <section class="cta-section">
    <div class="cta-container">
      <h2 class="cta-title">Ready to Start Shopping?</h2>
      <p class="cta-subtitle">Join thousands of happy customers and discover amazing products</p>
      <div class="cta-actions">
        <p-button 
          label="Explore Marketplace" 
          icon="pi pi-shopping-bag"
          (onClick)="goToMarketplace()"
          [raised]="true"
          styleClass="cta-button"
        ></p-button>
      </div>
    </div>
  </section>
</div>
